import { Injectable, computed, inject } from "@angular/core";
import { LanguageService } from "./language.service";
import { SupportedLanguagesEnum } from "@app/views-interfaces";

@Injectable({ providedIn: "root" })
export class DateService {
    private readonly languageService = inject(LanguageService);

    public readonly dateFormat = computed(() => {
        const language = this.languageService.language();
        return language === SupportedLanguagesEnum.French ? "MMM dd, yyyy" : "dd MMM yyyy";
    });

    public readonly dateTimeFormat = computed(() => {
        const language = this.languageService.language();
        const dateFormat = this.dateFormat();
        return language === SupportedLanguagesEnum.French ? `${dateFormat} HH:mm:ss` : `${dateFormat} hh:mm:ss aa`;
    });

    public readonly fullDateTimeFormat = computed(() => {
        const dateTimeFormat = this.dateTimeFormat();
        return `EEEE, ${dateTimeFormat}`;
    });
}
